
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class ProductSerialsDialog extends Serenity.EntityDialog<ProductSerialsRow, any> {
        protected getFormKey() { return ProductSerialsForm.formKey; }
        protected getIdProperty() { return ProductSerialsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductSerialsRow.localTextPrefix; }
        protected getNameProperty() { return ProductSerialsRow.nameProperty; }
        protected getService() { return ProductSerialsService.baseUrl; }

        protected form = new ProductSerialsForm(this.idPrefix);
        private activationLog2Grid: ActivationLog2Grid;
        private loadedState: string;
        constructor() {
            super();
            if (this.isNew()) {
               
                this.form.ProductId.changeSelect2(e => {
                    var productId = this.form.ProductId.value.toString();
                    if (Q.isEmptyOrNull(productId)) {
                        this.setProductDetails({});
                        return;
                    }
                    var id = Q.first(Workspace.ProductsRow.getLookup().items, x => x.Id.toString() == productId).Id;
                    Workspace.ProductsService.Retrieve({
                        EntityId: id
                    }, response => {
                        this.setProductDetails(response.Entity);
                    });
                });
            }
            this.activationLog2Grid = new ActivationLog2Grid(this.byId("ActivationLog2Grid"));
            this.activationLog2Grid.element.flexHeightOnly(1);
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);

            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        loadEntity(entity: ProductSerialsRow) {
            super.loadEntity(entity);           
            this.form.AccessStatus.changeSelect2(e => {
                this.showHidePaymentModeInfo();
            });
            this.showHidePaymentModeInfo();
            Serenity.TabsExtensions.setDisabled(this.tabs, 'ActivationHistory', this.isNewOrDeleted());

            this.activationLog2Grid.productSerialId = entity.Id;

        }
        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            if (this.form.TotalAllowedDuration.value == 0) {
                Q.alert("Total Allowed Duration cannot be Zero.");
                return false;
            }
            return isValidate;
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'ActivationHistory', this.isNewOrDeleted());

            this.loadedState = this.getSaveState();
        }

        showHidePaymentModeInfo() {
            if (this.form.AccessStatus.value != null) {
                var isChk = (this.form.AccessStatus.value == "2");
                this.form.SerialKeyItems.getGridField().toggle(isChk);
                if (isChk) {
                    //this.form.SerialKeyItems.value = "";
                    Serenity.EditorUtils.setRequired(this.form.SerialKeyItems, true);

                }
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // fill next number in new record mode
            debugger;
            if (this.isNewOrDeleted() == true) {
                var url = "/Workspace/ProductSerials";
                window.location.href = url;
            }
            if (this.isEditMode())
            {
                Serenity.EditorUtils.setReadonly(this.form.ProductId.element, true);
            }
            Serenity.EditorUtils.setReadonly(this.form.SerialKey.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.ValidityInDays.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.Views.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.WatchTime.element, true);
            this.activationLog2Grid.productSerialId = this.entityId;
            if (Authorization.hasPermission("Administration:Tenants") == false) {
                this.toolbar.findButton("delete-button").toggleClass("disabled", true);
            }
        }

        private setProductDetails(details: Workspace.ProductsRow) {
            //this.form.Views.value = details.Views;
            //this.form.WatchTime.value = details.WatchTime;
            //this.form.ValidityInDays.value = details.ValidityInDays;
            this.form.UpdateFrequencyInDays.value = details.UpdateFrequencyInDays;
            this.form.AllowSecondScreen.value = details.AllowSecondScreen;
            this.form.eViews.value = details.eViews.toString();
            this.form.eWatchTime.value = details.eWatchTime.toString();
            this.form.eValidity.value = details.eValidity.toString();
            this.form.UserId.value = details.UserId.toString();
           // this.form.Instance.value = 1;
            this.form.Status.value = "1";
        }

        private getNextSerialKey() {
            RecordShield.Workspace.ProductSerialsService.GetNextSerialKey({}, response => {
                this.form.SerialKey.value = response.SerialKey;
            });
        }
    }
}